import { useAbility } from '@casl/vue'
import type { AccessAbility, AccessScope, Permission } from '~/types/v2/Access'

/**
 * Whether the signed-in person has a permission, from the API's CASL rules
 * (plugins/casl.client.ts). Screens ask for a permission, never a role.
 *
 * The scope names the organisation, and for a workspace permission the
 * workspace too. A scope missing an id the permission needs answers no, so a
 * control stays hidden until its organisation has resolved. Reactive: the
 * answer follows the rules as they refresh.
 *
 * @example
 * const canManageMembers = useCan(Permission.OrganizationMembersManage, () => ({
 *   organizationId: organization.value?.id,
 * }))
 */
export function useCan(
  permission: MaybeRefOrGetter<Permission>,
  scope: MaybeRefOrGetter<AccessScope> = {},
) {
  const ability = useAbility<AccessAbility>()

  return computed(() => canAccess(ability, toValue(permission), toValue(scope)))
}
